import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import RFQModal from "../components/RFQModal";

const ClmSolution = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  return (
    <div id="clm-solutions">
      <Navbar />
      <div className="clm-intro">
        <div className="clm-intro-img" />
        <div className="clm-intro-cntnr">
          <div className="clm-intro-details" data-aos="fade-down">
            <div className="clm-intro-title">
              <h1>
                Customer Lifecycle Management
              </h1>
            </div>
            <div>
              <p>
                Unlock the Full Value of Your Customers{" "}
                <span className="Crtical-colour">At Outcess,</span>{" "}
                we help businesses manage and optimize the entire customer journey—from first contact to 
                long-term loyalty. Our AI-powered Customer Lifecycle Management (CLM) solutions improve customer 
                retention, boost engagement, and increase revenue by delivering personalized experiences at every stage.
              </p>
              <button className="ccsnl-btn cld-rfq-sm">
                Request for Consultation
              </button>
            </div>
          </div>
        </div>
      </div>
      <RFQModal show={show} setShow={setShow} />
      <main>
        <div className="clm-sltns-cards">
          <div
            className="clm-card-move"
            data-aos="fade-in"
            data-aos-delay="600">
            <div className="clm-card-img5">
              <h5>Smart Customer Segmentation </h5>
            </div>
            <div className="clm-card-details">
              <p>
                <ul className="clm-card-list">
                  <li>AI-driven insights to group customers based on behavior and preferences.</li>
                  <li>Personalized product recommendations and targeted marketing</li>
                </ul>
              </p>
            </div>
          </div>
          <div
            className="clm-card-move"
            data-aos="fade-in"
            data-aos-delay="600">
            <div className="clm-card-img6">
              <h5>Proactive Customer Engagement </h5>
            </div>
            <div className="clm-card-details">
              <p>
                <ul className="clm-card-list">
                  <li>AI chatbots and virtual assistants for instant support.</li>
                  <li>Omnichannel communication across digital, mobile, and contact centers.</li>
                  <li>Real-time insights to help customers make informed decisions.</li>
                </ul>
              </p>
            </div>
          </div>
          <div
            className="clm-card-move"
            data-aos="fade-in"
            data-aos-delay="600">
            <div className="clm-card-img4">
              <h5>Retention & Churn Prevention </h5>
            </div>
            <div className="clm-card-details">
              <p>
                <ul className="clm-card-list">
                  <li>AI-powered churn prediction to identify and retain at-risk customers.</li>
                  <li>Personalized loyalty programs and special offers.</li>
                  <li>Sentiment analysis to address issues before customers leave.</li>

                </ul>
              </p>
            </div>
          </div>
          <div
            className="clm-card-move"
            data-aos="fade-in"
            data-aos-delay="600">
            <div className="clm-card-img3">
              <h5>Dormant Account Reactivation </h5>
            </div>
            <div className="clm-card-details">
              <p>
                <ul className="clm-card-list">
                  <li>Automated re-engagement campaigns to win back inactive customers.</li>
                  <li>Incentive-based strategies to boost return rates.</li>
                </ul>
              </p>
            </div>
          </div>
        </div>
        <div className="clm-sltn-end">
          <div className="clm-end-details">
            <p>
            Why Choose Outcess?
            </p>
            <p>
                ✅ Increase customer retention with AI-driven insights. <br />
                ✅ Boost revenue by optimizing engagement at every stage. <br />
                ✅ Reduce churn with predictive analytics and proactive interventions. <br />
                ✅ Enhance digital adoption for seamless customer experiences.
            </p>
            <button className="ccsnl-btn" onClick={handleShow}>
              Request for Consultation
            </button>
          </div>
          <div
            className="clm-end-img"
            data-aos="fade-left"
            data-aos-delay="100"
          />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ClmSolution;
